import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pager from '../components/Pager';
/* eslint-disable consistent-return */
class PagerContainer extends Component {
  constructor(props) {
    super(props);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.enabled = {
      next: true,
      previous: true,
    };
  }

  componentWillReceiveProps(props) {
    this.prepareButtons(props);
  }

  static afterStepChange() {
    window.scrollTo(0,
      0);
  }

  nextStep() {
    if (!this.enabled.next) {
      return null;
    }

    const i = this.props.currentStep - 1;
    const step = this.props.steps[i];
    let validate;
    // @see App.js, Because of ExtraServicesContainer is inside div, we have to do this ugly stuff.
    if (step.type === 'div') {
      validate = () => {
        return Promise.all(
          step.props.children.map(element =>
            element && element.type.validate
              ? element.type.validate(element.props)
              : Promise.resolve()
          )
        );
      };
    } else {
      validate = () =>
        step.type.validate ? step.type.validate(step.props) : Promise.resolve();
    }

    validate().then(
      () => {
        PagerContainer.afterStepChange();
        this.props.nextStep();
      },
      () => {
        this.props.dispatchScrollToInvalid();
        PagerContainer.afterStepChange();
      }
    );
  }

  prepareButtons(props) {
    const index = props.currentStep;
    const total = this.props.totalSteps;

    this.enabled.previous = index !== 1;
    this.enabled.next = index !== total;

    if (index === 1 && index === total) {
      this.enabled.previous = false;
      this.enabled.next = false;
    }
  }

  prevStep() {
    if (!this.enabled.previous) {
      return null;
    }

    PagerContainer.afterStepChange();
    this.props.prevStep();
  }

  render() {
    const i = this.props.currentStep;
    const total = this.props.totalSteps;
    if (i === 1 && i === total) return null;

    const { additionalClassName, currentStep } = this.props;

    return (
      <Pager
        additionalClassName={additionalClassName}
        current={currentStep}
        nextDisabled={!this.enabled.next}
        nextStep={this.nextStep}
        prevDisabled={!this.enabled.previous}
        prevStep={this.prevStep}
        total={total}
      />
    );
  }
}

PagerContainer.PropTypes = {
  additionalClassName:PropTypes.string,
  currentStep:PropTypes.number.isRequired,
  nextStep:PropTypes.func.isRequired,
  prevStep:PropTypes.func.isRequired,
  steps:PropTypes.node,
  totalSteps:PropTypes.number.isRequired,
};

export default PagerContainer;
